import React, {FC} from 'react';
import messages from './messages';
import {MODAL} from 'features/modal-notch/constants';
import {Edit, Trash2} from 'react-feather';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {DropdownMenu, DropdownItem} from 'reactstrap';
import {UncontrolledDropdown, DropdownToggle} from 'reactstrap';
import showModal from 'store/ui/actions/show-modal';
import {uiActions} from 'store/ui/ui-slice';
import {DirectoryFamily} from 'types/directory-family';
import Button from 'components/button';

interface Props {
  family: DirectoryFamily;
}

const CategoryActions: FC<Props> = props => {
  const {family} = props;

  const dispatch = useDispatch();

  const {t} = useTranslation();

  const handleDestroy = () => {
    dispatch(
      uiActions.confirmDelete({
        resourceId: family.id,
        name: 'directory-families',
      })
    );
  };

  const handleEdit = () => {
    dispatch(showModal(MODAL.DIRECTORY_FAMILY_FORM_UPDATE, family));
  };

  const hasActions = true;
  return (
    <div className="d-flex align-items-center h-100">
      <Button
        tag="button"
        color="transparent"
        className="me-2"
        onClick={handleEdit}
      >
        <Edit size={20} />
      </Button>

      {/* <Can action="delete" subject="directory-category"> */}
      <Button onClick={handleDestroy} color="transparent">
        <Trash2 size={20} className="text-danger" />
      </Button>
      {/* </Can> */}
    </div>
  );
};

export default CategoryActions;
